export enum Routes {
  /**
   * @deprecated use {@link getAccountSettingUrls}
   */
  Account = '/account',
  AccountSettings = '/settings/account/:tab',
  OrganizationSettings = '/settings/organization/:tab',
  CandidateDetails = '/candidates/:candidateId',
  Candidates = '/candidates',
  AllSchedulingTasks = '/all-tasks',
  MySchedulingTasks = '/my-tasks',
  Employees = '/employees',
  InterviewModuleDetails = '/interviews/:interviewModuleId',
  InterviewerDetails = '/interviewers/:interviewerId',
  Interviews = '/interviews',
  JobDetails = '/jobs/:jobId/:tab',
  JobDetailsWithJobStage = '/jobs/:jobId/:tab/:jobStageId',
  Jobs = '/jobs',
  JobSettingsImport = '/job-settings-import',
  Metrics = '/metrics',
  TaskSuggestedSchedules = '/task-suggested-schedules/:taskId',
  TranscriptInterview = '/transcript/:applicationStageId/:interviewId',
  UpcomingEvents = '/upcomingevents',
  TermsAndPrivacy = '/terms-and-privacy',
  GrantAccess = '/grant-access/:integrationType',
  Extension = '/extension',
  /** Canonical authenticated destination for the global AI Agent. */
  Agent = '/agent',
  AgentThread = '/agent/:threadId',
  AiScheduling = '/ai-scheduling',
  Notifications = '/notifications',
}

export enum MetricsPageTabs {
  RECRUITERS = 'recruiters',
  INTERVIEWERS = 'interviewers',
  SURVEYS = 'surveys',
  TTS = 'tts',
  DEBRIEF = 'debrief',
}

/** Identifies the organization settings page that owns a synced job setting. */
export enum OrgSettingsSource {
  JOB_SETTINGS = 'job_settings',
  TEMPLATES = 'templates',
  ORG_PRIVACY = 'org_privacy',
  BRANDING_THEME = 'branding_theme',
  SCHEDULING = 'scheduling',
  SCHEDULE_LOCATION = 'schedule_location',
  DEBRIEF_LOCATION = 'debrief_location',
  RESCHEDULING = 'rescheduling',
  INTERVIEW_PLAN_SYNC = 'interview_plan_sync',
  COMMUNICATION = 'communication',
  DEBRIEF = 'debrief',
  INTERNAL_COMMUNICATION = 'internal_communication',
  CANDIDATE_AVAILABILITY_REQUEST = 'candidate_availability_request',
  SELF_SCHEDULE_REQUESTS = 'candidate_requests',
  ORG = 'org',
  CANDIDATE_PULSE_SURVEY = 'candidate_pulse_survey',
  ORG_SETUP = 'org_setup',
}
